import React, { useEffect, createRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useLazyQuery, useMutation } from '@apollo/client';
import Papa from 'papaparse';

import Form from 'react-bootstrap/Form';
import Toast from 'react-bootstrap/Toast';


import { ADMIN_UPDATE_LINKS, ADMIN_UPDATE_PRODUCTS } from "../utils/mutations";

function parseCsv(f) {
  return new Promise((resolve, reject) =>
    Papa.parse(f, {complete: resolve, error: reject})
  );
}

function Admin() {
  const dispatch = useDispatch();

  return (
    <div>
        <h2>Admin</h2>

        <ul>
          <li><Link to="/admin-links">Manage Affiliate Links</Link></li>
          <li><Link to="/admin-products">Manage Products</Link></li>
        </ul>
    </div>
  );
}

export default Admin;
